import * as THREE from 'three';

/**
 * IR decoy flare — compact glowing pellet with a hot core (trail spawned in ArcadeGame).
 * Local +Z is nose-forward for orientation consistency.
 */
const SHELL = 0xffab40;
const CORE = 0xfff59d;
const HOT = 0xff6f00;

export function createFlare(): THREE.Group {
  const flare = new THREE.Group();
  flare.name = 'arcade-flare';

  const shellMat = new THREE.MeshBasicMaterial({ color: SHELL });
  const coreMat = new THREE.MeshBasicMaterial({ color: CORE });
  const hotMat = new THREE.MeshBasicMaterial({ color: HOT, transparent: true, opacity: 0.95 });

  // Pellet body
  const body = new THREE.Mesh(new THREE.BoxGeometry(0.22, 0.22, 0.38), shellMat);
  flare.add(body);
  const core = new THREE.Mesh(new THREE.BoxGeometry(0.14, 0.14, 0.28), coreMat);
  core.position.z = 0.02;
  flare.add(core);
  // Hot tip / burn face
  const tip = new THREE.Mesh(new THREE.BoxGeometry(0.18, 0.18, 0.12), hotMat);
  tip.position.z = 0.22;
  flare.add(tip);

  flare.userData.radius = 0.85;
  flare.userData.kind = 'flare';
  return flare;
}
